import { render, staticRenderFns } from "./Bangun.vue?vue&type=template&id=3e8d8f00"
import script from "./Bangun.vue?vue&type=script&lang=js"
export * from "./Bangun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports